import React from 'react';
import { View } from '@apps/createBabyRegistry/components/View';
import { JoyLogoLoader } from '@shared/components/JoyLogoLoader';
import { BabyContentWrapper } from '@apps/createBabyRegistry/CreateBabyRegistry.styles';
import { useCreateBabyRegistryController } from '@apps/createBabyRegistry/CreateBabyRegistry.controller';
import { Box } from '@withjoy/joykit';
import { useFeatureValue } from '@shared/core/featureFlags';
import { Redirect } from '@react-router';

export const CreateBabyRegistry = () => {
  const { isLoading, desiredView } = useCreateBabyRegistryController();

  const { value: remoteBrSignupEnabled, loading } = useFeatureValue('babyRegistrySignupEnabled');
  const babyRegistrySignupEnabled = remoteBrSignupEnabled === 'on';

  if (!babyRegistrySignupEnabled && !loading) {
    return <Redirect to="/" />;
  }

  if (isLoading || loading) {
    return <JoyLogoLoader loaderKey="create-baby-registry" />;
  }

  return (
    <Box as="main">
      <BabyContentWrapper paddingTop={[0, 7]} paddingBottom={[0, 8]} paddingX={[0, 7]} flexDirection="column" alignItems="center" justifyContent={['start', 'center']}>
        <View defaultView={desiredView} />
      </BabyContentWrapper>
    </Box>
  );
};
